import {Box, IconReceipt, Inline, Stack, Text} from '@treatwell/ui';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../../hooks/store';
import {selectRescheduleDepositFormatted} from '../../store/slices/selectors';
import styles from './Deposit.module.css';

interface Props {
  amount: string;
}

export const Deposit = ({amount}: Props) => {
  const {t} = useTranslation();

  return (
    <Box className={styles.root} padding="base" data-cy="Deposit">
      <Inline space="base" align="start">
        <IconReceipt size={24} className={styles.icon} />
        <Stack space="sm">
          <Text as="p" type="bodyHeavy">
            {t('reschedule.deposit.paid', {amount})}
          </Text>
          <Text as="p" type="body">
            {t('reschedule.deposit.staysWithBooking')}
          </Text>
        </Stack>
      </Inline>
    </Box>
  );
};

export const DepositCompact = ({amount}: Props) => {
  const {t} = useTranslation();

  return (
    <Text as="p" type="caption" data-cy="DepositCompact">
      {t('reschedule.deposit.paid', {amount})}
    </Text>
  );
};

interface ContainerProps {
  compact?: boolean;
}

export const DepositContainer = ({compact = false}: ContainerProps = {}) => {
  const deposit = useAppSelector(selectRescheduleDepositFormatted);

  if (!deposit) {
    return null;
  }

  return compact ? (
    <DepositCompact amount={deposit.amount} />
  ) : (
    <Deposit amount={deposit.amount} />
  );
};
